import { createSlice } from '@reduxjs/toolkit';
import { ButtonType } from 'common/constant';

interface MyTabWindow {
  type: ButtonType;
  tabWindow: Window;
}

type TabWindowState = {
  myTabsWindow: MyTabWindow[];
};

const initialState: TabWindowState = {
  myTabsWindow: [],
};

export const tabWindowSlice = createSlice({
  name: 'tabWindow',
  initialState,
  reducers: {
    addTabWindow: (state, action) => {
      const distinctTabsByType = state.myTabsWindow.filter((myTabWindow) => {
        if (myTabWindow.type === action.payload.type) {
          myTabWindow.tabWindow.close();
          return false;
        }

        return true;
      });

      state.myTabsWindow = [...distinctTabsByType, action.payload];
    },

    removeAllTabWindow: (state) => {
      state.myTabsWindow = [];
    },
  },
});

export const { addTabWindow, removeAllTabWindow } = tabWindowSlice.actions;

export default tabWindowSlice.reducer;
